"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Co2.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Co2 = function Co2(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 222.06 149.15"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "co2 Icon"), _react2.default.createElement("g", {
    className: "CO2",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    className: "cloud",
    d: "M173.2 149.15H48.9a48.9 48.9 0 1 1 0-97.8h1.2a38 38 0 0 1 42.7-19.3 55 55 0 0 1 104.9 23.1 26.2 26.2 0 0 1-.1 2.8 48.88 48.88 0 0 1-24.4 91.2zM48.9 59.35a40.9 40.9 0 1 0 0 81.8h124.3a40.85 40.85 0 0 0 18.5-77.3l-2.4-1.2.3-2.7a37.75 37.75 0 0 0 .2-4.7 47 47 0 0 0-91-16.8l-1.3 3.6-3.7-1.3a30 30 0 0 0-37.5 16.2l-1 2.4h-6.4z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M97 97.35a1.76 1.76 0 0 1 1.3.6l3.4 3.7a19.42 19.42 0 0 1-7 5.4 24.71 24.71 0 0 1-10 1.9 24.45 24.45 0 0 1-9.3-1.8 20.17 20.17 0 0 1-7-4.9 22.52 22.52 0 0 1-4.5-7.6 28.45 28.45 0 0 1-1.6-9.6 25.91 25.91 0 0 1 1.7-9.6 23.23 23.23 0 0 1 4.7-7.5 21.34 21.34 0 0 1 7.3-4.9 23.38 23.38 0 0 1 9.4-1.7 22 22 0 0 1 9.1 1.7 21.37 21.37 0 0 1 6.7 4.3l-2.9 4a2.34 2.34 0 0 1-.7.7 2 2 0 0 1-1.1.3 1.69 1.69 0 0 1-1-.3c-.3-.2-.7-.4-1.1-.7s-.9-.6-1.4-.9a10.84 10.84 0 0 0-1.9-.8 16.2 16.2 0 0 0-5.7-1 15.62 15.62 0 0 0-5.7 1.1 12.82 12.82 0 0 0-4.5 3.2 14.81 14.81 0 0 0-2.9 5.2 20.83 20.83 0 0 0-1 7 20.92 20.92 0 0 0 1.1 7 16.83 16.83 0 0 0 3 5.2 12 12 0 0 0 4.5 3.2 15.51 15.51 0 0 0 5.6 1.1c1.1 0 2.1-.1 3.2-.2a13.1 13.1 0 0 0 2.7-.6 9.73 9.73 0 0 0 2.3-1.1 17.68 17.68 0 0 0 2.2-1.6 4.23 4.23 0 0 1 .7-.5c-.1-.2.2-.3.4-.3zm54.2-12.4a25.75 25.75 0 0 1-1.7 9.5 23.32 23.32 0 0 1-4.8 7.6 21 21 0 0 1-7.5 5 26.77 26.77 0 0 1-19.3 0 21 21 0 0 1-7.5-5 23.32 23.32 0 0 1-4.8-7.6 27 27 0 0 1 0-19 23.32 23.32 0 0 1 4.8-7.6 21 21 0 0 1 7.5-5 26.9 26.9 0 0 1 9.7-1.8 30 30 0 0 1 6.7.8 23.49 23.49 0 0 1 5.7 2.3 20.73 20.73 0 0 1 4.7 3.7 18.51 18.51 0 0 1 3.5 4.8 22.45 22.45 0 0 1 2.2 5.8 24.12 24.12 0 0 1 .8 6.5zm-8.8 0a23 23 0 0 0-1-6.9 14.81 14.81 0 0 0-2.9-5.2 15 15 0 0 0-4.6-3.3 17.37 17.37 0 0 0-12.3 0 11.85 11.85 0 0 0-4.7 3.3 15.05 15.05 0 0 0-3 5.2 23.2 23.2 0 0 0 0 13.8 15.05 15.05 0 0 0 3 5.2 12.69 12.69 0 0 0 4.7 3.2 17.37 17.37 0 0 0 12.3 0 11.58 11.58 0 0 0 4.6-3.2 14.81 14.81 0 0 0 2.9-5.2 22.59 22.59 0 0 0 1-6.9zm33.4 33a1.66 1.66 0 0 1 1.3.5 1.85 1.85 0 0 1 .5 1.2v3h-20.2v-1.7a4.25 4.25 0 0 1 .2-1.1 2.29 2.29 0 0 1 .7-1l9-9c.7-.8 1.4-1.5 2-2.2a11.26 11.26 0 0 0 1.5-2.1 7.84 7.84 0 0 0 .9-2.1 8.33 8.33 0 0 0 .3-2.2 6.28 6.28 0 0 0-.3-1.9 4.19 4.19 0 0 0-.9-1.4 2.48 2.48 0 0 0-1.4-.8 5.66 5.66 0 0 0-1.8-.3 9.85 9.85 0 0 0-1.7.2 4.3 4.3 0 0 0-2.4 1.8 3.79 3.79 0 0 0-.6 1.3 2.15 2.15 0 0 1-.9 1.2 2.22 2.22 0 0 1-1.6.1l-2.6-.5a12.34 12.34 0 0 1 1.2-3.7 9.34 9.34 0 0 1 2.2-2.7 8.7 8.7 0 0 1 3-1.6 9.23 9.23 0 0 1 3.7-.5 11.48 11.48 0 0 1 3.7.6 7.85 7.85 0 0 1 4.8 4.4 8.29 8.29 0 0 1 .7 3.4 10.47 10.47 0 0 1-.5 3 16.64 16.64 0 0 1-1.3 2.7 15.45 15.45 0 0 1-1.9 2.4c-.7.8-1.5 1.6-2.3 2.4l-6.6 6.8a12.86 12.86 0 0 1 1.9-.4c.6-.1 1.2-.1 1.8-.2l7.6.4z",
    className: "CO2-2",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11
    },
    __self: undefined
  })));
};
exports.default = Co2;